import _ from 'lodash';
import { DatasetStatus } from '@retro-ui/api-contract';

import { DatasetSearchParam, DatasetsById } from '../SearchParameterForm';

export type SelectedDatasetMap = _.Dictionary<DatasetSearchParam>;

export function buildSelectedDatasetMap(
  datasets: DatasetSearchParam[],
  datasetsByExtendedId: DatasetsById
) {
  return _.chain(datasets)
    .filter(item => {
      const { id: extendedId } = item;
      const dataset = datasetsByExtendedId[extendedId];
      return dataset?.status === DatasetStatus.READY;
    })
    .keyBy('id')
    .value();
}
